import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { getData, postData } from "src/utils/axios/serverHelper";
import { formatDate } from "src/utils/string/stringUtil";
import { PRD5011_R01Dto, PRD5011_R01ProductResultDto } from "./Dto_PRD5011_R01";
import { PRD5011_R01Filter } from "./Store_PRD5011_R01";

const baseUrl = `${config.apiUrl}/PRD5011_R01`;

const getParams = (filter: Partial<PRD5011_R01Filter>) => ({
    compCd: filter.compCd || undefined,
    kpicertkey: filter.kpicertkey || undefined,
    kpifldcd: filter.kpifldcd || undefined,
    startDate: filter.ocrdttmDateRange?.from
        ? formatDate(filter.ocrdttmDateRange.from)
        : undefined,
    endDate: filter.ocrdttmDateRange?.to
        ? formatDate(filter.ocrdttmDateRange.to)
        : undefined,
});

export const getPRD5011_R01List = async (option: string, filter: Partial<PRD5011_R01Filter>) => {
    const url = `${baseUrl}/${option}`;
    return await getData<ResponseDto<PRD5011_R01Dto[]>>(url, { params: getParams(filter) });
};

export interface PRD5011_R01ProductResultParams {
    productDt: string;
    compCd?: string;
    kpifldcd?: string;
}

export const getPRD5011_R01ProductResultList = async (params: PRD5011_R01ProductResultParams) => {
    const url = `${baseUrl}/productResult/`;
    return await getData<ResponseDto<PRD5011_R01ProductResultDto[]>>(url, {
        params: {
            compCd: params.compCd || undefined,
            kpifldcd: params.kpifldcd || undefined,
            productDt: params.productDt,
        },
    });
};

export const exportPRD5011_R01Excel = async (option: string, filter: Partial<PRD5011_R01Filter>) => {
    const url = `${baseUrl}/excel/${option}`;
    return await getData<ResponseDto<string>>(url, { params: getParams(filter) });
};

export const postPRD5011_R01KpidataInsert = async (data: PRD5011_R01Dto[]) => {
    const url = `${baseUrl}/kpidata/insert`;
    return await postData<PRD5011_R01Dto[], ResponseDto<void>>(url, data);
};
